import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ChangePassword from '@portal/common/components/ChangePassword';
import { withGoogleAnalytics } from '@portal/common/services/google-analytics';

import { changeAccountPassword, signOut } from '../../../store/session/actions';
import { getSessionAccountId } from '../../../store/session/selectors';

const ChangePasswordTab: FC = () => {
    const dispatch = useDispatch();
    const accountId = useSelector(getSessionAccountId);

    const handleChangePassword = useCallback(
        (password, newPassword) =>
            dispatch(changeAccountPassword(accountId, password, newPassword)),
        [accountId]
    );

    const handleNext = useCallback(() => {
        setTimeout(() => {
            dispatch(signOut());
        }, 1000);
    }, []);

    return <ChangePassword changePassword={handleChangePassword} onNext={handleNext} />;
};

export default withGoogleAnalytics({
    trackMethods: (props) => ({
        handleChangePassword: (account) =>
            props.trackEvent({
                category: 'Account',
                action: 'Change Password',
            }),
    }),
})(ChangePasswordTab);
